module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-5.305a5e8b.jpg";